"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NMRium = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
require("@blueprintjs/core/lib/css/blueprint.css");
require("@blueprintjs/icons/lib/css/blueprint-icons.css");
const react_1 = require("react");
const react_error_boundary_1 = require("react-error-boundary");
const ui_1 = require("react-science/ui");
const ErrorOverlay_1 = __importDefault(require("./ErrorOverlay"));
const InnerNMRium_1 = require("./InnerNMRium");
const NMRiumBase = (0, react_1.forwardRef)(function NMRium(props, ref) {
    const { noErrorBoundary = false, onError, ...otherProps } = props;
    const innerNmrium = (0, jsx_runtime_1.jsx)(InnerNMRium_1.InnerNMRium, { ...otherProps, innerRef: ref });
    const children = noErrorBoundary ? (innerNmrium) : ((0, jsx_runtime_1.jsx)(react_error_boundary_1.ErrorBoundary, { FallbackComponent: ErrorOverlay_1.default, onError: onError, children: innerNmrium }));
    return (0, jsx_runtime_1.jsx)(ui_1.RootLayout, { style: { width: '100%' }, children: children });
});
exports.NMRium = (0, react_1.memo)(NMRiumBase);
